import { useMemo } from 'react';

import { SelectedUpgrade } from './types';
import { Baggage } from '../../BaggageService/types';
import { Segment } from '../types';
import { getSelectedServicesBySegments } from '../AdditionalBaggage/utils';
import { getPriceToPay } from '../../BaggagePage/utils';

export const serviceForMultipleSegments = (service: Baggage): boolean => {
	return service.segmentIds[0]?.length > 1;
};

export const useSelectedServicesBySegments = (
	services: Baggage[],
	segments: Segment[],
	selectedServices: SelectedUpgrade[]
) => {
	const selectedItems = useMemo(() => {
		const selectedServicesBySegments = getSelectedServicesBySegments(services, selectedServices, segments);

		return selectedServicesBySegments.sort((a, b) => {
			if (a.allSegments && !b.allSegments) {
				return -1;
			} else if (!a.allSegments && b.allSegments) {
				return 1;
			}

			return +a.service.id - +b.service.id;
		});
	}, [services, selectedServices, segments]);

	const totalPrice = useMemo(() => getPriceToPay(selectedServices, services), [selectedItems, services]);

	return {
		selectedItems,
		hasSelected: selectedItems.length > 0,
		totalPrice
	};
};
